import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/door/open/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/door/open/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/door/open/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/door/open/submit', params, options);

export const update = (params, options) => request.post('/api/door/open/submit', params, options);
